import Button from "components/lib/Shared/Button";
import { ChevronLeftIcon } from "components/lib/Shared/Icons/sflIcons";
import { useDispatch, useSelector } from "react-redux";
import { setActivePeriodTab } from "state/slices/transferYourBusiness";
import { getFullName } from "utils";

const ApplicantDetails = (props) => {
  const { handleGoForward, activeYearIndex, setActiveYearIndex } = props;

  const dispatch = useDispatch();

  const currentUser = useSelector((state) => state.userSlice);
  const fields = [
    {
      name: "fullName",
      key: "Full Name",
      value: getFullName(currentUser?.names),
    },
    {
      name: "phoneNumber",
      key: "Phone Number",
      value: currentUser?.electronicAddress?.mobileNumber,
    },
    {
      name: "phoneNumber",
      key: "Phone Number",
      value: getFullName(currentUser?.names),
    },
    {
      name: "role",
      key: "Role",
      value: "Registrar",
    },
  ];
  const handleYearTabsNavigation = () => {
    if (activeYearIndex > 0) {
      setActiveYearIndex(activeYearIndex - 1);
      dispatch(setActivePeriodTab(activeYearIndex - 1));
    }
  };

  return (
    <div>
      <div className="px-4 py-6 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
        <div className="flex flex-col space-y-2">
          {fields.map((field, index) => (
            <div key={`${field.key}_${index}`} className="flex flex-col">
              <div className="flex items-baseline justify-between">
                <label
                  htmlFor={field.name}
                  className="block mb-2 text-sm text-primary font-medium min-w-[13rem] w-52 whitespace-normal"
                >
                  {field.key}
                </label>

                <div
                  className={`bg-formInput flex w-[80%] justify-between relative`}
                >
                  {field.value}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        className={`flex ${
          activeYearIndex > 0 ? "justify-between" : "justify-end"
        } mt-4`}
      >
        {activeYearIndex > 0 && (
          <button
            type="button"
            onClick={handleYearTabsNavigation}
            className="flex items-start float-right p-2 font-semibold rounded text-primary hover:bg-gray-700 hover:text-white"
          >
            <span className="flex items-center mr-4 h-7">
              <ChevronLeftIcon
                className="flex-shrink-0 w-5 h-5"
                aria-hidden="true"
              />
            </span>
            <p className="font-semibold">Go back</p>
          </button>
        )}
        <Button
          type="button"
          onClick={handleGoForward}
          className="flex px-2 py-2 text-white button button-hover button-disabled button-outline button-focus bg-sflPrimary"
        >
          Next Page
        </Button>
      </div>
    </div>
  );
};

export default ApplicantDetails;
